import React from "react";
import { RiMovie2Line } from "react-icons/ri";
import { Link } from "react-router-dom";

const StartPage = () => {
  return (
    //creating background image with fainted appearance
    <div className="relative w-full lg:h-full h-screen">
      <img
        src="/images/wallpaper.jpg"
        alt="start-page"
        className="object-cover w-full h-full"
      />

      {/* movie channel logo and sign section */}
      <div className="absolute top-0 left-0 w-full h-full px-4 bg-gray-900/60 flex flex-row justify-between">
        <div className="lg:block col-span-1">
          <div className="flex font-bold text-subMain my-2 text-4xl md:text-8xl">
            O{" "}
            <span className="flex text-xl md:text-5xl text-white py-2 md:py-7">
              scar'sTv
              <RiMovie2Line color="red" />
            </span>
          </div>
        </div>

        <div className="my-4 md:my-8 mr-4 z-10">
          <Link
            className="bg-subMain text-white font-bold hover:bg-white hover:text-subMain rounded px-4 py-2 w-24"
            to="/startlogin"
          >
            Sign In
          </Link>
        </div>
      </div>

      {/* background body */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-white text-center mt-5 md:mt-auto">
        <h1 className="font-normal md:font-bold text-xl md:text-6xl px-4 md:px-0">
          Unlimited movies, TV shows, and more.
        </h1>

        <p className="text-gray-100 text-sm md:text-2xl py-1 md:py-8 px-4 md:leading-loose">
          Watch anywhere. Cancel anytime. <br />{" "}
          <span>
            Ready to watch? Enter your email to create or restart your
            membership.
          </span>
        </p>

        <div className="flex flex-row items-center">
          <input
            type="email"
            name=""
            placeholder="Email Address"
            className="w-44 md:w-9/12 h-7 md:h-20 text-black px-4 rounded-l"
          />
          <button className="bg-subMain text-white md:font-bold px-4 h-7 md:h-20 rounded-r">
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartPage;
